import { createStore, applyMiddleware }
                            from 'redux';
import { createLogger }     from 'redux-logger';
import reducers             from './reducers';

export default function configureStore(initialState = {}) {
    const createStoreWithMiddleware = process.env.NODE_ENV == 'development' ?
        applyMiddleware(
            createLogger()
        )(createStore) :
        applyMiddleware(
        )(createStore);

    const store = createStoreWithMiddleware(
        reducers,
        initialState
    );

    window.store = store;

    return store;
}
